"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInsurerSwaggerMetadata = addInsurerSwaggerMetadata;
exports.getAllInsurersSwaggerMetadata = getAllInsurersSwaggerMetadata;
exports.getInsurerByIdSwaggerMetadata = getInsurerByIdSwaggerMetadata;
exports.modifyInsurerSwaggerMetadata = modifyInsurerSwaggerMetadata;
exports.deleteInsurerSwaggerMetadata = deleteInsurerSwaggerMetadata;
exports.getInsurerDetailsSwaggerMetadata = getInsurerDetailsSwaggerMetadata;
exports.getInsurerListSwaggerMetadata = getInsurerListSwaggerMetadata;
exports.getInsurerContactsSwaggerMetadata = getInsurerContactsSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
function addInsurerSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Add a new insurer",
        description: "Creates a new insurer with the provided details, including address information.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Details of the insurer to be created, including address information.",
        schema: {
            type: "object",
            properties: {
                insurerName: { type: "string", example: "sagar 123" },
                displayName: { type: "string", example: "Test Display" },
                companyTypeLid: { type: "number", example: 19 },
                website: { type: "string", example: "http://example.com" },
                isLifeLid: { type: "number", example: 83 },
                companyTagLid: { type: "number", example: 21 },
                insureCode: { type: "string", example: "ABC" },
                remarks: { type: "string", example: "Test remarks" },
                address: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            addressTypeLid: { type: "number", example: 25 },
                            address1: { type: "string", example: "test nagar ofice" },
                            address2: { type: "string", example: "SD Road" },
                            countryId: { type: "number", example: 1 },
                            stateId: { type: "number", example: 1 },
                            cityId: { type: "number", example: 1 },
                            area: { type: "string", example: "test" },
                            pinCode: { type: "string", example: "92912" },
                            phoneNumber: { type: "string", example: "1234567890" },
                            alternatePhoneNumber: { type: "string", example: "1234567890" },
                            email: { type: "string", example: "test@gmail.com" },
                            supportNumber: { type: "string", example: "test" },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer successfully created.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "Insurer successfully created." },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 211 },
                        insurerName: { type: "string", example: "sagar 123" },
                        displayName: { type: "string", example: "Test Display" },
                        companyTypeLid: { type: "number", example: 19 },
                        companyTag: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 21 },
                                lookUpValue: { type: "string", example: "Preferred" },
                            },
                        },
                        companyType: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 19 },
                                lookUpValue: { type: "string", example: "Public" },
                            },
                        },
                        isLife: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 83 },
                                lookUpValue: { type: "string", example: "Yes" },
                            },
                        },
                        status: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 85 },
                                lookUpValue: { type: "string", example: "Active" },
                            },
                        },
                        website: { type: "string", example: "http://example.com" },
                        companyTagLid: { type: "number", example: 21 },
                        remarks: { type: "string", example: "Test remarks" },
                        insureCode: { type: "string", example: "ABC" },
                        policy: { type: "array", items: { type: "object" }, example: [] },
                        insurerAddresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1364 },
                                    addressTypeLid: { type: "number", example: 25 },
                                    addressType: {
                                        type: "object",
                                        properties: {
                                            id: { type: "number", example: 25 },
                                            lookUpValue: { type: "string", example: "Office" },
                                        },
                                    },
                                    address1: { type: "string", example: "test nagar ofice" },
                                    countryId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "India" },
                                            isoCode: { type: "string", example: null },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    stateId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Andhra Pradesh" },
                                            stateCode: { type: "string", example: "AP" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    cityId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Visakhapatnam" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    address2: { type: "string", example: "SD Road" },
                                    area: { type: "string", example: "test" },
                                    pinCode: { type: "string", example: "92912" },
                                    phoneNumber: { type: "string", example: "1234567890" },
                                    alternatePhoneNumber: {
                                        type: "string",
                                        example: "1234567890",
                                    },
                                    email: { type: "string", example: "test@gmail.com" },
                                    supportNumber: { type: "string", example: "test" },
                                },
                            },
                        },
                        insurerContacts: {
                            type: "array",
                            items: { type: "object", properties: {} },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
    }));
}
function getAllInsurersSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get all insurers",
        description: "Retrieves a list of all insurers, including their associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        example: 1,
        description: "Page number for pagination (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        example: 10,
        description: "Number of records per page (optional)(by default limit is 10 records).",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        example: "insurerName:DESC",
        description: "Field to sort by (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        example: "companyTag:general,insurerName:new",
        description: "Search term to filter results (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "searchBy",
        required: false,
        example: "test",
        description: "Search based on insurerName, companyTag",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer list retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Insurer list retrieved successfully",
                },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 79 },
                                    insurerName: { type: "string", example: "sagar" },
                                    displayName: { type: "string", example: "Test Display" },
                                    status: {
                                        type: "object",
                                        properties: {
                                            id: { type: "number", example: 87 },
                                            lookUpValue: {
                                                type: "string",
                                                example: "UNDER_REVIEW",
                                            },
                                        },
                                    },
                                    insurerAddresses: {
                                        type: "array",
                                        items: {
                                            type: "object",
                                            properties: {
                                                id: { type: "number", example: 72 },
                                                address1: {
                                                    type: "string",
                                                    example: "test nagar ofice",
                                                },
                                                city: {
                                                    type: "object",
                                                    properties: {
                                                        name: {
                                                            type: "string",
                                                            example: "Visakhapatnam",
                                                        },
                                                        id: { type: "number", example: 1 },
                                                    },
                                                },
                                                state: {
                                                    type: "object",
                                                    properties: {
                                                        name: {
                                                            type: "string",
                                                            example: "Andhra Pradesh",
                                                        },
                                                        stateCode: { type: "string", example: "AP" },
                                                        id: { type: "number", example: 1 },
                                                    },
                                                },
                                                phoneNumber: { type: "string", example: "test" },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                        count: { type: "number", example: 3 },
                        totalActiveInsurers: { type: "number", example: 67 },
                        totalActivepolacies: { type: "number", example: 0 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No insurers found.",
    }));
}
function getInsurerByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get an insurer by ID",
        description: "Retrieves details of a specific insurer by its ID, including associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Insurer retrieved successfully",
                },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 79 },
                        insurerName: { type: "string", example: "sagar" },
                        displayName: { type: "string", example: "Test Display" },
                        companyTypeLid: { type: "number", example: 19 },
                        companyTag: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 21 },
                                lookUpValue: { type: "string", example: "High Priority" },
                            },
                        },
                        companyType: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 19 },
                                lookUpValue: { type: "string", example: "Public" },
                            },
                        },
                        isLife: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 83 },
                                lookUpValue: { type: "string", example: "Yes" },
                            },
                        },
                        status: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 87 },
                                lookUpValue: { type: "string", example: "UNDER_REVIEW" },
                            },
                        },
                        website: { type: "string", example: "http://example.com" },
                        companyTagLid: { type: "number", example: 21 },
                        remarks: { type: "string", example: "Test remarks" },
                        insureCode: { type: "string", example: "ABC" },
                        policy: { type: "array", items: { type: "object" }, example: [] },
                        insurerAddresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 386 },
                                    addressTypeLid: { type: "number", example: 25 },
                                    addressType: {
                                        type: "object",
                                        properties: {
                                            id: { type: "number", example: 25 },
                                            lookUpValue: { type: "string", example: "Official" },
                                        },
                                    },
                                    address1: { type: "string", example: "test nagar ofice" },
                                    countryId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "India" },
                                            isoCode: { type: "string", example: null },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    stateId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Andhra Pradesh" },
                                            stateCode: { type: "string", example: "AP" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    cityId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Visakhapatnam" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    address2: { type: "string", example: "" },
                                    area: { type: "string", example: "test" },
                                    pinCode: { type: "string", example: "92912" },
                                    phoneNumber: { type: "string", example: "test" },
                                    alternatePhoneNumber: { type: "string", example: "" },
                                    email: { type: "string", example: "test@gmail.com" },
                                    supportNumber: { type: "string", example: "test" },
                                },
                            },
                        },
                        insurerContacts: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {},
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Insurer not found.",
    }));
}
function modifyInsurerSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update an insurer",
        description: "Updates the details of an existing insurer.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Updated insurer details, including addresses",
        schema: {
            type: "object",
            properties: {
                insurerName: { type: "string", example: "abhi varmasss" },
                displayName: { type: "string", example: "Test Display" },
                companyTypeLid: { type: "number", example: 19 },
                website: { type: "string", example: "http://example.com" },
                isLifeLid: { type: "number", example: 83 },
                companyTagLid: { type: "number", example: 21 },
                remarks: { type: "string", example: "Test remarks" },
                insureCode: { type: "string", example: "ABCD" },
                address: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 375 },
                            addressTypeLid: { type: "number", example: 25 },
                            address1: {
                                type: "string",
                                example: "test nagar oficefhedwhfwhf",
                            },
                            countryId: { type: "number", example: 1 },
                            stateId: { type: "number", example: 1 },
                            cityId: { type: "number", example: 1 },
                            address2: { type: "string", example: "" },
                            area: { type: "string", example: "test" },
                            pinCode: { type: "string", example: "92912" },
                            phoneNumber: { type: "string", example: "87975922557" },
                            alternatePhoneNumber: {
                                type: "string",
                                example: "87975922557",
                            },
                            email: { type: "string", example: "test@gmail.com" },
                            supportNumber: { type: "string", example: "test" },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer updated successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "Insurer successfully updated." },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 73 },
                        insurerName: { type: "string", example: "abhi varmasss" },
                        displayName: { type: "string", example: "Test Display" },
                        companyTypeLid: { type: "number", example: 19 },
                        website: { type: "string", example: "http://example.com" },
                        isLifeLid: { type: "number", example: 83 },
                        companyTagLid: { type: "number", example: 21 },
                        remarks: { type: "string", example: "Test remarks" },
                        insureCode: { type: "string", example: "ABCD" },
                        statusLid: { type: "number", example: 85 },
                        address: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 375 },
                                    addressTypeLid: { type: "number", example: 25 },
                                    address1: {
                                        type: "string",
                                        example: "test nagar oficefhedwhfwhf",
                                    },
                                    countryId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "India" },
                                            isoCode: { type: "string", example: null },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    stateId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Andhra Pradesh" },
                                            stateCode: { type: "string", example: "AP" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    cityId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Visakhapatnam" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    address2: { type: "string", example: "" },
                                    area: { type: "string", example: "test" },
                                    pinCode: { type: "string", example: "92912" },
                                    phoneNumber: { type: "string", example: "test" },
                                    alternatePhoneNumber: { type: "string", example: "" },
                                    email: { type: "string", example: "test@gmail.com" },
                                    supportNumber: { type: "string", example: "test" },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Insurer not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
    }));
}
function deleteInsurerSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Delete an insurer",
        description: "Deletes an insurer by its ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer successfully deleted.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: "Insurer successfully deleted." },
                data: {
                    type: "object",
                    properties: {
                        message: {
                            type: "string",
                            example: "Insurer successfully deleted.",
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Insurer not found.",
    }));
}
function getInsurerDetailsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get insurer details by ID",
        description: "Retrieves details of a specific insurer by its ID, including associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "ID of the insurer",
        example: 44,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer details retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Insurer details retrieved successfully",
                },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 44 },
                        insurerName: { type: "string", example: "Abhi" },
                        displayName: { type: "string", example: "Test Display" },
                        insurerAddresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 325 },
                                    address1: { type: "string", example: "test nagar ofice" },
                                    city: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Visakhapatnam" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Insurer not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getInsurerListSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get all insurers",
        description: "Retrieves a list of all insurers, including their associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        example: 1,
        description: "Page number for pagination (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        example: 10,
        description: "Number of records per page (optional)(by default limit is 10 records).",
    }), (0, swagger_1.ApiQuery)({
        name: "sortBy",
        required: false,
        example: "createdAt",
        description: "Field to sort by (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "sortOrder",
        required: false,
        example: "ASC",
        description: "Sort order: ASC or DESC (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        example: "Test",
        description: "Search term to filter results (optional).",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurers retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Insurers retrieved successfully",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 44 },
                            insurerName: { type: "string", example: "Abhi" },
                            displayName: { type: "string", example: "Test Display" },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No insurers found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getInsurerContactsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get contacts of an insurer",
        description: "Fetches all contacts associated with a specific insurer.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "insurerId",
        required: true,
        description: "ID of the insurer",
        example: 123,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Insurer contacts retrieved successfully.",
        schema: {
            example: {
                status: 200,
                message: "Insurer contacts retrieved successfully",
                data: [
                    {
                        id: 584,
                        firstName: "uday",
                        lastName: "yama",
                        displayName: "Uday Yama",
                    },
                    {
                        id: 579,
                        firstName: "insurer",
                        lastName: "update",
                        displayName: "insurer update12",
                    },
                ],
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No contacts found for insurer.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Failed to fetch insurer contacts.",
    }));
}
